const formatter = new Intl.NumberFormat('en-US', {
	currency: 'USD',
	style: 'currency'
});

export const formatPrice = (str) => {
	return formatter.format(str);
};
